import React from 'react';

const InputNomeCompleto = ({
  id,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const handleInput = (e) => {
    e.target.value = Array.from(e.target.value)
      .filter((character) => /[a-zA-Z\s]/.test(character)) // Permite letras e espaços
      .join('');
  };
  const handleKeyDown = (event) => {
    if (
      !(
        event.key === 'Backspace' ||
        event.key === 'Delete' ||
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowRight' ||
        event.key === 'ArrowUp' ||
        event.key === 'ArrowDown' ||
        event.key === 'Tab' ||
        (event.key.length === 1 && event.key.match(/^[a-zA-Z0-9\s.]$/))
      )
    ) {
      event.preventDefault(); // Impede a ação padrão da tecla
    }
  };
  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo-txt ${msgErro ? 'erro' : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>

      <div className="input-container">
        <input
          type={'text'}
          id={id}
          name={name}
          ref={inputRef}
          className={msgErro ? 'invalid' : ''}
          onInput={(e) => handleInput(e)}
          onKeyDown={handleKeyDown}
          {...rest}
        />
      </div>
      <div className="mensagem legenda">{msgErro}</div>
    </div>
  );
};

export default InputNomeCompleto;
